import React from "react"
import ItemCover from "components/ItemCover"
import { type ProductTndb } from "services/axiosService"
import { TableCell, TableRow } from "@/components/ui/table"

interface RowProps {
  product: ProductTndb
  onSelect: (product: ProductTndb) => void
}

const sliced = (name: string) => {
  const maxLength = 29
  if (name.length > maxLength) return name.slice(0, maxLength) + "..."

  return name
}
export const SelectProductsEcommerceTableRow: React.FC<RowProps> = ({ product, onSelect }) => {
  const cover = product.variants?.[0]?.imageUrl || ""
  const name = product.name
  const numberOfVariants = product.variants?.length ?? 0

  return (
    <TableRow
      onClick={() => onSelect(product)}
      className="cursor-pointer transition-colors duration-300 hover:bg-gray-600"
    >
      <TableCell className="w-16 !pl-10">
        <ItemCover cover={cover} name="" size={40} />
      </TableCell>
      <TableCell className="truncate">
        <span className="text-foreground">{sliced(name)}</span>
      </TableCell>
      <TableCell className="text-center">
        <span className="text-foreground">{numberOfVariants}</span>
      </TableCell>
    </TableRow>
  )
}
